import { SAVED_SEARCH_COLOR_MAP } from '../constants/colors';
import {
  SCOPE_CONTRACT_AWARDS,
  SCOPE_CONTRACT_OPPORTUNITIES,
  SCOPE_GRANT_OPPORTUNITIES,
  SCOPE_STATE_LOCAL_CONTRACT_OPPORTUNITIES,
} from '../constants';

export const FREQUENCY_INSTANT = 'INSTANT';
export const FREQUENCY_DAILY = 'DAILY';
export const FREQUENCY_WEEKLY = 'WEEKLY';
export const FREQUENCY_NONE = 'NONE';

export const FREQUENCY_LABEL_KEYS = {
  [FREQUENCY_INSTANT]: 'frequency-real-time',
  [FREQUENCY_DAILY]: 'frequency-daily-recap',
  [FREQUENCY_WEEKLY]: 'frequency-weekly-recap',
  [FREQUENCY_NONE]: 'frequency-off',
};

export const FREQUENCY_OPTIONS = [FREQUENCY_INSTANT, FREQUENCY_DAILY, FREQUENCY_WEEKLY, FREQUENCY_NONE].map(
  (value) => ({ value, labelKey: FREQUENCY_LABEL_KEYS[value] })
);

export const EMAIL_SCOPES = [
  SCOPE_CONTRACT_AWARDS,
  SCOPE_CONTRACT_OPPORTUNITIES,
  SCOPE_GRANT_OPPORTUNITIES,
  SCOPE_STATE_LOCAL_CONTRACT_OPPORTUNITIES,
];

export function isEmailScope(scope) {
  return EMAIL_SCOPES.includes(scope);
}

export function getSavedSearchFrequency(item) {
  if (!item?.watch) return FREQUENCY_NONE;
  const { notification } = item;
  if (notification === FREQUENCY_NONE) return FREQUENCY_NONE;
  if (notification === FREQUENCY_INSTANT || notification === FREQUENCY_WEEKLY) return notification;
  return FREQUENCY_DAILY;
}

export function getColorAndPercentage(current, limit) {
  const status = current > 0 && current >= limit ? 'over' : 'normal';
  const color = SAVED_SEARCH_COLOR_MAP[status];

  const currentValue = current > limit ? limit : current;
  const percentageValue = (currentValue / limit) * 100;

  return { color, percentageValue };
}

export function isUnlimitedSearchTier(savedSearchStats) {
  return savedSearchStats?.savedSearchLimitTier === null;
}

export function hasFiniteSearchLimit(savedSearchStats) {
  return typeof savedSearchStats?.savedSearchLimitTier === 'number';
}
